import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl as withIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';

import trackOnlineHelpClicked from '@care/tracking/trackOnlineHelpClicked';

import { goBack } from '@shared/actions';
import getPrevLocationFullUrl from '@shared/selectors/getPrevLocationFullUrl';

const mapStateToProps = createStructuredSelector({
  prevLocationFullUrl: getPrevLocationFullUrl,
});

const mapDispatchToProps = {
  trackOnlineHelpClicked,
  goBack,
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withIntl);
